<template>
    <div class="newsletter__container" v-if=showBlock>
        <h2 class="newsletter__title">{{getTranslateString("Get exclusive offers & the latest news")}}</h2>
        <form class="newsletter__form"
            novalidate
            v-on:submit.prevent="send()">
            <div class="newsletter-inner__form"
                v-bind:class="{'has-error' : fields.email && !fields.email.valid && fields.email.touched,
                'is-validated' : fields.email && fields.email.valid && fields.email.touched}">
                <input type="email"
                    name="email"
                    :placeholder="getTranslateString('E-mail')"
                    v-model="email"
                    v-validate="'required|email'"
                    required
                    class="newsletter__input">

                <vue-ladda
                    button-class="newsletter__button"
                    :loading="isLoading"
                    data-style="zoom-in">
                    <i class="dd-m-icon icon-send"></i>
                </vue-ladda>

                <div class="dd-m-form__error-msg" v-if="errors.length">
                    <span v-for="(error, index) in errors" :key="index">
                        {{error}}
                    </span>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

    import NewsletterService from '../../providers/api/newsletter-service';   
    const newsletterService = new NewsletterService();
    

    export default {
        name: 'opt-in',
        data: () => {
            return {
            	showBlock: false,
                isLoading: false,
                email: null,
                errors: []
            }
        },
        mounted() {
        	this.showBlock = window.show_subscribe_block;
        },
        methods: {
            send() {
                if (this.email) {
                    this.errors = [];
                    this.isLoading = true;
                    newsletterService.doSubscribe(this.email)
                        .then(() => {
                            PubSub.publish('showNewsletterSuccessModal');
                            this.isLoading = false;
                        })
                        .catch((err) => {

                            if (err.response.data.error.validations) {
                                const validations = err.response.data.error.validations;

                                for (const k in validations) {
                                    if (validations.hasOwnProperty(k)) {
                                        this.errors.push(validations[k][0]);
                                    }
                                }

                            } else {
                                this.errors = [err.response.data.error.message];
                            }

                            this.isLoading = false;
                        });
                }
            }
        }
    }
</script>

<style scoped>
.newsletter__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0 10px;
    border-top: 1px solid #c8c8c8;
}
.newsletter__title,
.newsletter__form {
    width: 50%;
}
.newsletter__title {
    text-transform: uppercase;
    font-weight: 400;
    font-size: 20px;
    font-family: "zonapro", Arial, Helvetica, sans-serif;
}
.newsletter-inner__form {
    display: flex;
}
input.newsletter__input {
    border-radius: 25px 0 0 25px;
    border: 1px solid #d0d0d0;
    border-right: none;
    width: 100%;
    padding: 0 25px;
    font-family: "zonapro", Arial, Helvetica, sans-serif;
    height: 36px;
    line-height: 36px;
}
.newsletter__button {
    border: 1px solid #d0d0d0;
    border-left: none;
    border-radius: 0 25px 25px 0;
    appearance: none;
    background: transparent;
    box-shadow: none;
    height: 36px;
    width: 44px;
    
}
.newsletter__button .icon-send:before {
    content: "\E90A";
    color: #de0284;
    font-size: 8px;
    transform: translatex(-5px) rotate(-90deg);
    display: block;
    transform-origin: top;
}

@media (max-width: 768px) {
    .newsletter__container {
        flex-direction: column;
    }
    .newsletter__title,
    .newsletter__form {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/site/js/components/opt-in/opt-in.vue